import { render, staticRenderFns } from "./VQNumber.vue?vue&type=template&id=d6ab2fd8&scoped=true&"
import script from "./VQNumber.vue?vue&type=script&lang=js&"
export * from "./VQNumber.vue?vue&type=script&lang=js&"
import style0 from "./VQNumber.vue?vue&type=style&index=0&id=d6ab2fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ab2fd8",
  null
  
)

export default component.exports